module.exports = __webpack_public_path__ + "media/images/ohap_Course_icon_blue-8e967769a33e50b89b7bc95fadbbe471.png";